import { ILayer, ILabel } from '../../../types/common';

const source = 'labels';

const config = {
  id: source,
  type: 'symbol',
  source: source,
  layout: {
    'text-field': ['get', 'description'],
    'text-variable-anchor': ['top', 'bottom', 'left', 'right'],
    'text-radial-offset': 0.5,
    'text-justify': 'auto',
    'text-size': 14,
  },
  paint: {
    'text-color': '#000',
    'text-halo-color': '#fff',
    'text-halo-width': 1,
  },
};

const load = (labels: ILabel[]): ILayer => {
  const data = {
    type: 'FeatureCollection',
    features: labels.map((label) => ({
      type: 'Feature',
      properties: {
        description: label.text,
      },
      geometry: {
        type: 'Point',
        coordinates: label.coordinates,
      },
    })),
  };

  return {
    data,
    config,
    source,
    labels: null,
    markers: null,
  };
};

export default load;
